import React, { useEffect, useState } from "react";
import axios from "axios";

import PageHeader from "../components/PageHeader";
import Loader from "../components/Loader";
import StatCard from "../components/StatCard";

import API_URL from "../../config";

const Reports = () => {

    const [loading, setLoading] = useState(true);

    const [reportData, setReportData] = useState({

        totalCandidates: 0,

        totalRecruiters: 0,

        totalJobs: 0,

        totalApplications: 0,

        totalRevenue: 0,

        activeSubscriptions: 0,

        pendingPayments: 0,

        rejectedApplications: 0

    });

    const [monthlyRevenue, setMonthlyRevenue] = useState([]);

    const [recentPayments, setRecentPayments] = useState([]);

    const [topRecruiters, setTopRecruiters] = useState([]);

    const [filters, setFilters] = useState({

        fromDate: "",

        toDate: ""

    });

    useEffect(() => {

        fetchReports();

    }, []);

    const fetchReports = async () => {

        try {

            setLoading(true);

            const response = await axios.get(

                `${API_URL}/admin/reports`,

                {

                    params: filters

                }

            );
            const data = response.data.data;

            setReportData(data.summary || {});
            setMonthlyRevenue(data.monthlyRevenue || []);
            setRecentPayments(data.recentPayments || []);
            setTopRecruiters(data.topRecruiters || []);

        } catch (error) {

            console.error("Error fetching reports:", error);

        } finally {

            setLoading(false);

        }

    };

    const handleFilterChange = (e) => {

        const {

            name,

            value

        } = e.target;

        setFilters({

            ...filters,

            [name]: value

        });

    };

    const applyFilters = () => {

        fetchReports();

    };

    const clearFilters = () => {

        setFilters({

            fromDate: "",

            toDate: ""

        });

    };
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Reports..."
            />

        );

    }

    return (
        <div className="space-y-6">

            <PageHeader

                title="Reports & Analytics"

                subtitle="Platform insights and business reports"

                showButton={false}

                breadcrumb={[
                    {
                        label: "Dashboard",
                        link: "/admin"
                    },
                    {
                        label: "Reports"
                    }
                ]}

            />

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-end">

        <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
                From Date
            </label>

            <input
                type="date"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleFilterChange}
                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:ring-2 focus:ring-teal-500"
            />
        </div>

        <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
                To Date
            </label>

            <input
                type="date"
                name="toDate"
                value={filters.toDate}
                onChange={handleFilterChange}
                className="w-full rounded-xl border border-gray-300 px-4 py-2 focus:ring-2 focus:ring-teal-500"
            />
        </div>

        <div className="flex gap-3">

            <button
                onClick={applyFilters}
                className="px-5 py-2 rounded-xl bg-teal-600 text-white hover:bg-teal-700"
            >
                Apply
            </button>

            <button
                onClick={clearFilters}
                className="px-5 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
            >
                Clear
            </button>

        </div>

    </div>

</div>

           <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
                <div>

                    <StatCard

                        title="Candidates"

                        value={reportData.totalCandidates}

                        icon="bi bi-people-fill"

                        color="primary"

                    />

                </div>

                <div>

                    <StatCard

                        title="Recruiters"

                        value={reportData.totalRecruiters}

                        icon="bi bi-building"

                        color="success"

                    />

                </div>

                <div>

                    <StatCard

                        title="Jobs"

                        value={reportData.totalJobs}

                        icon="bi bi-briefcase-fill"

                        color="warning"

                    />

                </div>

                <div>

                    <StatCard

                        title="Applications"

                        value={reportData.totalApplications}

                        icon="bi bi-file-earmark-text-fill"

                        color="info"

                    />

                </div>

                <div>

                    <StatCard

                        title="Revenue"

                        value={`₹ ${Number(reportData.totalRevenue || 0).toLocaleString()}`}

                        icon="bi bi-cash-stack"

                        color="danger"

                    />

                </div>

                <div>

                    <StatCard

                        title="Subscriptions"

                        value={reportData.activeSubscriptions}

                        icon="bi bi-award-fill"

                        color="secondary"

                    />

                </div>

                <div>

                    <StatCard

                        title="Pending Payments"

                        value={reportData.pendingPayments}

                        icon="bi bi-credit-card-fill"

                        color="warning"

                    />

                </div>

                <div>
                    <StatCard

                        title="Rejected Applications"

                        value={reportData.rejectedApplications}

                        icon="bi bi-x-circle-fill"

                        color="dark"

                    />

                </div>

            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

                <div>

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                        <div className="px-6 py-4 border-b">
    <h2 className="text-lg font-semibold">
        Recent Payments
    </h2>
</div>

                        <div className="overflow-x-auto">
                             <table className="min-w-full divide-y divide-gray-200">

                                <thead className="bg-gray-100">
                                        <tr>
                                            <th className="px-4 py-3 text-left font-semibold">Company</th>
                                            <th className="px-4 py-3 text-left font-semibold">Plan</th>
                                            <th className="px-4 py-3 text-left font-semibold">Amount</th>
                                        </tr>
                                 </thead>

                                <tbody>

                                    {recentPayments.length === 0 ? (

                                        <tr>

                                            <td
                                                colSpan="3"
                                                className="text-center text-muted"
                                            >

                                                No payment records found.

                                            </td>

                                        </tr>

                                    ) : (

                                        recentPayments.map((payment) => (

                                            <tr key={payment.id}>

                                               <td className="px-4 py-3">
                                                        {payment.company_name}
                                                    </td> 

                                                <td>{payment.plan_name}</td>

                                                <td>

                                                    ₹ {Number(payment.amount).toLocaleString()}

                                                </td>

                                            </tr>

                                        ))

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

                <div>

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                        <div className="px-6 py-4 border-b">

                            <h5 className="mb-0">

                                Top Recruiters

                            </h5>

                        </div>

                        <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                <thead>

                                    <tr>

                                        <th>Company</th>

                                        <th>Jobs</th>

                                        <th>Applications</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    {topRecruiters.length === 0 ? (

                                        <tr>

                                            <td
                                                colSpan="3"
                                                className="text-center text-muted"
                                            >

                                                No recruiter data found.

                                            </td>

                                        </tr>

                                    ) : (

                                        topRecruiters.map((recruiter) => (

                                            <tr key={recruiter.id}>

                                                <td>{recruiter.company_name}</td>

                                                <td>{recruiter.total_jobs}</td>

                                                <td>{recruiter.total_applications}</td>

                                            </tr>

                                        ))

                                    )}

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

                <div className="xl:col-span-2 bg-white rounded-3xl shadow-lg">

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                             <div className="px-6 py-4 border-b">

                                <h5 className="mb-0">

                                   Monthly Revenue

                                 </h5>

                             </div>

                       <div className="p-6">

                            {monthlyRevenue.length === 0 ? (

                                <div className="text-center py-5">

                                    <p className="text-muted">

                                        No revenue data available.

                                    </p>

                                </div>

                            ) : (

                                <table className="min-w-full divide-y divide-gray-200">

                                    <thead className="table-light">

                                        <tr>

                                            <th>Month</th>

                                            <th>Revenue</th>

                                            <th>Payments</th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {monthlyRevenue.map((item, index) => (

                                            <tr key={index}>

                                                <td>

                                                    {item.month}

                                                </td>

                                                <td>

                                                    ₹ {Number(item.revenue || 0).toLocaleString()}

                                                </td>

                                                <td>

                                                    {item.payments}

                                                </td>

                                            </tr>

                                        ))}

                                    </tbody>

                                </table>

                            )}

                        </div>

                    </div>

                </div>

                <div className="bg-white rounded-3xl shadow-lg">

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                        <div className="px-6 py-4 border-b">

                            <h5 className="mb-0">

                                Application Summary

                            </h5>

                        </div>

                        <div className="p-6">

                            <table className="min-w-full divide-y divide-gray-200">

                                <tbody>

                                    <tr>

                                        <td>

                                            Total Applications

                                        </td>

                                        <td>

                                            {reportData.totalApplications}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>

                                            Rejected

                                        </td>

                                        <td>

                                            {reportData.rejectedApplications}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>

                                            Active Jobs

                                        </td>

                                        <td>

                                            {reportData.totalJobs}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>

                                            Active Recruiters

                                        </td>

                                        <td>

                                            {reportData.totalRecruiters}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

                <div>

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                        <div className="px-6 py-4 border-b">

                            <h5 className="mb-0">

                                Subscription Analytics

                            </h5>

                        </div>

                        <div className="overflow-x-auto p-6">

                            <table className="min-w-full">

                                <tbody>

                                    <tr>

                                        <td>

                                            Active Subscriptions

                                        </td>

                                        <td>

                                            {reportData.activeSubscriptions}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>

                                            Pending Payments

                                        </td>

                                        <td>

                                            {reportData.pendingPayments}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>

                                            Total Revenue

                                        </td>

                                        <td>

                                            ₹ {Number(reportData.totalRevenue || 0).toLocaleString()}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

                <div>

                    <div className="bg-white rounded-3xl shadow-lg overflow-hidden">

                        <div className="px-6 py-4 border-b">

                            <h5 className="mb-0">

                                Charts

                            </h5>

                        </div>

                        <div className="card-body text-center">

                            <div
                              className="border rounded-xl flex justify-center items-center"
                                style={{
                                    height: "250px",
                                    background: "#fafafa"
                                }}
                            >

                                <div>

                                    <i
                                        className="bi bi-bar-chart-line-fill text-primary"
                                        style={{
                                            fontSize: "60px"
                                        }}
                                    ></i>

                                    <h6 className="mt-3">

                                        Chart Placeholder

                                    </h6>

                                    <p className="text-muted">

                                        Connect Chart.js or Recharts here.

                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">

               <div className="bg-white rounded-3xl shadow-lg p-6">

<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

<h2 className="text-xl font-bold">
Export Reports
</h2>

<div className="flex gap-3">

<button
onClick={()=>{
console.log("Export CSV")
}}
className="px-5 py-2 rounded-xl bg-green-600 text-white hover:bg-green-700"
>
Export CSV
</button>

<button
onClick={()=>{
console.log("Export PDF")
}}
className="px-5 py-2 rounded-xl bg-red-600 text-white hover:bg-red-700"
>
Export PDF
</button>

</div>

</div>

<p className="text-gray-500">
Export the current report using the selected date filters.
CSV and PDF APIs can be connected here.
</p>

</div>

            </div>

        </div>

    );

};

export default Reports;